import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { CategoryHero, CategoryGrid, CategoryReviews } from "./components/CategorySections";
import { useParams } from "react-router-dom";

const categoryNames: Record<string, string> = {
  "wanghong-tafang": "网红塌房",
  "heiliao-baoliao": "黑料爆料",
  "chigua-video": "吃瓜视频",
};

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const categoryName = categoryNames[slug || ""] || "分类";

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: `${categoryName} | 在线吃瓜官网`,
    description: `${categoryName} - 最新最全的${categoryName}内容合集，在线吃瓜官网每日更新`,
    url: `https://zaixianchigua.com/category/${slug}`,
    isPartOf: {
      "@type": "WebSite",
      name: "在线吃瓜官网",
      url: "https://zaixianchigua.com",
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <CategoryHero />
        <CategoryGrid />
        <CategoryReviews />
      </main>
      <Footer />
    </>
  );
}